import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'token-header',
    templateUrl: './token-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TokenHeaderComponent {
   
}